export default __webpack_public_path__ + "static/media/icn_agents.fa2d75b0.svg";